module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt":{"data":"Dados","home":"Loja de Apps","settings":"Ajustes","views":"Páginas","workflows":"Automações"},"en":{"data":"Data","home":"App Store","settings":"Settings","views":"Pages","workflows":"Automations"}}')
  delete Component.options._Ctor
}
